import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/app/games/')({
  staticData: { title: 'Games' },
  component: GamesPage,
});

function GamesPage() {
  return (
    <div className="p-4 md:p-6">
      <h1>Games</h1>
    </div>
  );
}
